import React from 'react';
import LockerOneScenarios from './components/LockerOneScenarios';
import './index.css';

function App() {
  return (
    <div className="App">
      <LockerOneScenarios />
    </div>
  );
}

export default App;